import { useContext, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PaginationComponent from "../../components/common/PaginationModal";
import { FaEdit } from "react-icons/fa";
import CalendarFilter from "../../components/common/CalenderFilter";
import ConfirmationModal from "../../components/common/ConfirmationModal";
import SuccessModal from "../../components/common/SuccessModal";
import NoResultFoundModel from "../../components/common/NoDataFound";
import ErrorModal from "../../components/common/ErrorModel";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import {
      DeleteClient,
} from "../../services/Client/ClientApi";
import {
      GetClientList, ChangeClientStatus, UpdateTenderStatus
} from "../../services/Client/ClientApi";
import TenderPreviewDialog from "./TenderPreviewDialog";
import Android12Switch from "../../components/common/AndroidSwitch";
import JobsAddUpdateModal from "./JobsAddUpdateModal";
import { JobEnum } from "../../middleware/enum";
import { GetJobList, UpdateJobStatus, UpdateStatusJob } from "../../services/Job/JobApi";
import PreviewDialog from "./PreviewDialog";
import { MdOutlinePreview } from "react-icons/md";
import JobStatusDialog from "./JobStatusDialog";
import AddProjectModal from "../Project/AddProjectModal";
import { hasModuleAction } from "../../Utils/stringFormatter";
import TenderStatusDialog from "../Client/TenderStatusDialog";
import {
      FaEye,
      FaFileAlt,
      FaCheckCircle,
      FaClock,
      FaTimesCircle,
      FaTimes,
} from "react-icons/fa";


const JobsList = () => {
      const navigate = useNavigate();
      const location = useLocation();

      //==================Context==========================
      const { setLoader } = useContext(LoaderContext);
      const { authDetails, pageSize, defaultAccess } = useContext(AuthContext);
      const { userKeyID } = JSON.parse(localStorage.getItem("login"))
      const { listType, clientID } = location.state || {};
      const [isAddProjectOpen, setAddProjectOpen] = useState(false);
      const [updateTenderDialogOpen, setUpdateTenderDialogOpen] = useState(false)
      //========================column and table==========================
      const allTabs = [
            {
                  id: JobEnum.Job,
                  label: "Jobs",
                  accessKey: "ClientJobReportsCanView",
            },
            {
                  id: JobEnum.Tender,
                  label: "Tender",
                  accessKey: "ClientJobReportsCanView",
            },

      ];
      // =================== Column Configs =====================
      const tableColumnsConfig = {
            [JobEnum.Job]: [
                  { key: "jobName", label: "Job Name" },
                  { key: "projectName", label: "Project Name", },
                  { key: "clientName", label: "Client Name" },
                  { key: "categoryName", label: "Category" },
                  { key: "assignedTeamNames", label: "Assigned Team" },
                  { key: "startDate", label: "Start Date" },
                  { key: "endDate", label: "End Date" },
                  { key: "jobStatusName", label: "Job Status", isStatusAction: true },
                  { key: "jobChangeStatusRemark", label: "Remark", truncate: 10 },
                  { key: "status", label: "Status", isStatus: true },
            ],
            [JobEnum.Tender]: [
                  { key: "tenderID", label: "Tender Id/Quotation No." },
                  { key: "tenderName", label: "Tender Name" },
                  { key: "bidDate", label: "Bid Date" },
                  {
                        key: "tenderStatusName",
                        label: "Tender Status",
                        isTenderStatusAction: true,
                  },
                  { key: "tenderType", label: "Tender Type" },
                  { key: "tenderStatusRemark", label: "Remark", truncate: 10 },
                  { key: "status", label: "Status", isStatus: true },
            ]
      };

      const handleTenderStatusClick = (tender) => {
            setSelectedTender(tender);
            setUpdateTenderDialogOpen(true);
      };

      const handleTenderStatusUpdate = async (payload) => {
            setLoader(true);
            try {
                  const res = await UpdateTenderStatus({
                        userKeyID: userKeyID,
                        partiesKeyID: selectedTender.partiesKeyID, // tender ID
                        ...payload,
                  });

                  if (res.statusCode == 200) {
                        setUpdateTenderDialogOpen(false);
                        if (payload.tenderStatusID === 2) {
                              setModelRequestData({
                                    ...modelRequestData,
                                    KeyID: payload.projectKeyID,
                                    isTenderToProject: true,
                                    Action: "Update"
                              });
                              setAddProjectOpen(true)

                        } else {
                              setShowSuccessPopupModal(true);
                        }
                  }

                  // refresh table
                  // setAppliedFilter({ ...appliedFilter });
            } catch (error) {
                  console.error(error);
                  setUpdateTenderDialogOpen(false);
                  setIsErrorOpen(true);
                  setErrorMessage("Failed to update tender status.");
            } finally {
                  setLoader(false);
            }
      };

      // Render Table
      const renderTable = (columns = [], data = []) => {
            if (!columns.length) return null;


            const filteredColumns = columns.filter((col) => {
                  // Hide status column if no delete permission
                  if (!canDelete && col.key === "status") return false;

                  // Hide job status & remark if no change status permission
                  if (
                        !canChangeStatus &&
                        (col.key === "jobStatusName" || col.key === "jobChangeStatusRemark")
                  ) {
                        return false;
                  }

                  return true;
            });


            return (
                  <div className="flex flex-col table_wrapper border border-gray-200">
                        <div className="flex-1 overflow-y-auto">
                              <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                                    <thead>
                                          <tr className="z-1 sticky top-0 bg-white">
                                                {filteredColumns.map((col) => (
                                                      <th
                                                            key={col.key}
                                                            className="text-12 border-b border-slate-200 bg-slate-50 whitespace-nowrap p-2"
                                                      >
                                                            {col.label}
                                                      </th>
                                                ))}

                                                <th className="text-12 border-b border-slate-200 bg-slate-50 whitespace-nowrap p-2  sticky right-0 z-20">
                                                      Action
                                                </th>

                                          </tr>
                                    </thead>
                                    <tbody>
                                          {data.length > 0 ? (
                                                data.map((client, index) => (
                                                      <tr
                                                            key={index}
                                                            className="hover:bg-slate-50 border-b border-slate-200 text-center"
                                                      >
                                                            {filteredColumns.map((col) => {
                                                                  const value = client[col.key];

                                                                  if (col.truncate) {
                                                                        const truncated =
                                                                              value && value.length > col.truncate
                                                                                    ? value.slice(0, col.truncate) + "..."
                                                                                    : value;

                                                                        return (
                                                                              <td key={col.key} className="whitespace-nowrap px-2 py-0">
                                                                                    <Tooltip title={value || ""}>
                                                                                          <span className="cursor-pointer">{truncated}</span>
                                                                                    </Tooltip>
                                                                              </td>
                                                                        );
                                                                  }

                                                                  return (
                                                                        <td key={col.key} className="whitespace-nowrap px-2 py-0">
                                                                              {col.isStatusAction ? (
                                                                                    <Tooltip
                                                                                          title="Update Status"
                                                                                          onClick={() => {
                                                                                                handleStatusClick(client)
                                                                                                setModelAction("Status");
                                                                                          }
                                                                                          }
                                                                                          className="cursor-pointer text-[#135EA0] underline hover:text-[#0E4C84]"
                                                                                    >
                                                                                          {client[col.key]}

                                                                                    </Tooltip>
                                                                              ) : col.isTenderStatusAction ? (
                                                                                    <Tooltip
                                                                                          title="Update Status"
                                                                                          onClick={() => {
                                                                                                handleTenderStatusClick(client);
                                                                                                setModelAction("Status");
                                                                                          }}
                                                                                          className="cursor-pointer text-[#135EA0] underline hover:text-[#0E4C84]"
                                                                                    >
                                                                                          {client[col.key]}
                                                                                    </Tooltip>
                                                                              ) : col.isLink ? (
                                                                                    <Tooltip
                                                                                          title="View Project"
                                                                                          className="cursor-pointer"
                                                                                          onClick={() => {

                                                                                                handleViewClient(client)
                                                                                          }}
                                                                                    >
                                                                                          <span className="text-[#135EA0] hover:underline">
                                                                                                {client[col.key]}
                                                                                          </span>
                                                                                    </Tooltip>
                                                                              ) : col.isStatus ? (
                                                                                    canDelete && activeTab === 1 ? (
                                                                                          <div className="flex items-center space-x-4 justify-center">
                                                                                                <span className="text-12 font-medium w-[35px]">
                                                                                                      {client.status
                                                                                                            ? "Active"
                                                                                                            : "Inactive"}
                                                                                                </span>

                                                                                                <Tooltip title="Change Status">
                                                                                                      <Android12Switch
                                                                                                            checked={client.status}
                                                                                                            onClick={() => {

                                                                                                                  setModelRequestData({
                                                                                                                        ...modelRequestData,
                                                                                                                        jobKeyID: client.jobKeyID,
                                                                                                                        status:
                                                                                                                              client.status
                                                                                                                                    ? "InActive"
                                                                                                                                    : "Active",
                                                                                                                  });
                                                                                                                  setModelAction("Status");
                                                                                                                  setConfirmationModal(true);
                                                                                                            }}
                                                                                                      />
                                                                                                </Tooltip>

                                                                                          </div>) : (
                                                                                          <div className="flex items-center space-x-4 justify-center">
                                                                                                <span className="text-12 font-medium w-[35px]">
                                                                                                      {client.status
                                                                                                            ? "Active"
                                                                                                            : "Inactive"}
                                                                                                </span>

                                                                                                <Tooltip title="Change Status">
                                                                                                      <Android12Switch
                                                                                                            checked={client.status}
                                                                                                            onClick={() => {

                                                                                                                  setModelRequestData({
                                                                                                                        ...modelRequestData,
                                                                                                                        partiesKeyID: client.partiesKeyID,
                                                                                                                        status:
                                                                                                                              client.status
                                                                                                                                    ? "InActive"
                                                                                                                                    : "Active",
                                                                                                                  });
                                                                                                                  setModelAction("Status");
                                                                                                                  setConfirmationModal(true);
                                                                                                            }}
                                                                                                      />
                                                                                                </Tooltip>

                                                                                          </div>

                                                                                    )
                                                                              ) : (
                                                                                    client[col.key]
                                                                              )}
                                                                        </td>
                                                                  )
                                                            })}


                                                            <td className="whitespace-nowrap px-2 py-0 sticky right-0  bg-white z-10">
                                                                  {activeTab === 1 ? (
                                                                        <div className="flex justify-center gap-2">
                                                                              {canUpdate && (
                                                                                    <Tooltip title="Update Job" arrow>
                                                                                          <button
                                                                                                onClick={() => {

                                                                                                      setModelRequestData({
                                                                                                            ...modelRequestData,
                                                                                                            jobKeyID: client.jobKeyID,
                                                                                                            Action: "Update",
                                                                                                      })
                                                                                                      setAddProjectModalOpen(true)

                                                                                                }}
                                                                                                className="text-[#135EA0] hover:text-[#135EA0]"
                                                                                          >
                                                                                                <FaEdit className="text-12" />
                                                                                          </button>
                                                                                    </Tooltip>
                                                                              )}
                                                                              <Tooltip title="Preview" arrow>
                                                                                    <button
                                                                                          onClick={() => {
                                                                                                setSelectedClient(client);
                                                                                                setPreviewDialogOpen(true);
                                                                                          }}
                                                                                          className="text-[#135EA0] hover:text-[#135EA0]"
                                                                                    >
                                                                                          <MdOutlinePreview className="text-12" />
                                                                                    </button>
                                                                              </Tooltip>



                                                                        </div>
                                                                  ) : (
                                                                        <div className="flex justify-center gap-2">
                                                                              <Tooltip title="Preview" arrow>
                                                                                    <button
                                                                                          onClick={() => {
                                                                                                setSelectedClient(client);
                                                                                                setTenderPreviewDialogOpen(true);
                                                                                          }}
                                                                                          className="text-[#135EA0] hover:text-[#135EA0]"
                                                                                    >
                                                                                          <MdOutlinePreview className="text-12" />
                                                                                    </button>
                                                                              </Tooltip>
                                                                        </div>
                                                                  )}
                                                            </td>

                                                      </tr>
                                                ))
                                          ) : (
                                                <tr>
                                                      <td colSpan={filteredColumns.length + 1}>
                                                            <NoResultFoundModel totalRecords={totalRecords} />
                                                      </td>
                                                </tr>
                                          )}
                                    </tbody>
                              </table>
                        </div >

                        {/* Pagination */}
                        {(tableRows?.length >= pageSize || currentPage != 1) && (
                              <div className="flex justify-end">
                                    <PaginationComponent
                                          totalPages={Math.ceil(totalRecords / pageSize)}
                                          currentPage={currentPage}
                                          onPageChange={HandlePageChange}
                                    />
                              </div>
                        )}
                  </div >
            );
      };

      //=====================state===================
      const [activeTab, setActiveTab] = useState(null);
      const [tableRows, setTableRows] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);
      const [totalRecords, setTotalRecords] = useState(0);
      const [valueSearch, setValueSearch] = useState(null);
      const [searchTimer, setSearchTimer] = useState(null);
      const [fromDate, setFromDate] = useState(null);
      const [toDate, setToDate] = useState(null);
      const [isAddProjectModalOpen, setAddProjectModalOpen] = useState(false);
      const [errorMessage, setErrorMessage] = useState(false);
      const [isErrorOpen, setIsErrorOpen] = useState(false);
      const [previewDialogOpen, setPreviewDialogOpen] = useState(false)
      const [tenderPreviewDialogOpen, setTenderPreviewDialogOpen] = useState(false)
      const [selectedClient, setSelectedClient] = useState(null);
      const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
      const [confirmationModal, setConfirmationModal] = useState(false);
      const [modelAction, setModelAction] = useState("");
      const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
      //Dialog box
      const [isDocsStatusModalOpen, setIsDocsStatusModalOpen] = useState(false);
      const [selectedProject, setSelectedProject] = useState(null);
      const [tenderDialogOpen, setTenderDialogOpen] = useState(false);
      const [selectedTender, setSelectedTender] = useState(null);
      const [ClientListCount, setClientListCount] = useState(-1);
      const [ClientCurrentPage, setClientCurrentPage] = useState(1);
      const [projectNameState, setProjectNameState] = useState(
            location?.state?.projectName || null
      )

      const [projectType, setprojectType] = useState(
            location?.state?.projectType || null
      )

      const [clientNameState, setClientNameState] = useState(
            location?.state?.clientName || null
      )
      const [projectID, setprojectID] = useState(
            location?.state?.projectID || null
      )
      const [modelRequestData, setModelRequestData] = useState({
            KeyID: null,
            Action: null,
            isTenderToProject: null,
            status: null,
            remark: null,
            clientID: clientID,
            partiesKeyID: null
      });
      const [appliedFilter, setAppliedFilter] = useState(
            {
                  userKeyID: userKeyID,
                  pageNo: 0,
                  pageSize: pageSize,
                  sortingDirection: null,
                  sortingColumnName: null,
                  searchKeyword: null,
                  fromDate: null,
                  toDate: null,
                  listType: listType || null, //ClientProject, MyProject
                  projectID: projectID || null
            }
      )


      //=====================initial UseEffect=========================

      useEffect(() => {

            const params = new URLSearchParams(location.search);
            const tabFromURL = params.get("tab");

            const firstTab =
                  allTabs.find((tab) => defaultAccess?.[tab.accessKey]) || allTabs[0];

            let initialTab = firstTab.id;

            if (tabFromURL && allTabs.some((t) => t.id === Number(tabFromURL))) {
                  initialTab = Number(tabFromURL);
            }

            if (!tabFromURL) {
                  params.set("tab", initialTab);
                  navigate(`?${params.toString()}`, { replace: true });
            }

            setActiveTab(initialTab);
      }, [location.search]);


      useEffect(() => {

            async function fetchData() {
                  if (!activeTab) return;
                  if (activeTab === 1) {
                        setLoader(true);

                        const response = await GetJobList({
                              ...appliedFilter,
                              // partiesTypeID: activeTab,
                        });

                        setLoader(false);

                        if (response?.statusCode == 200) {
                              setTableRows(response.responseData.data);
                              setTotalRecords(response?.totalCount || response?.responseData?.data?.length || 0);
                        } else {
                              setTableRows([]);
                              setTotalRecords(0);
                        }
                  }
                  else {
                        setLoader(true);

                        const response = await GetClientList({
                              ...appliedFilter,
                              partiesTypeID: 2
                        });

                        setLoader(false);

                        if (response?.statusCode == 200) {
                              setTableRows(response.responseData.data);
                              setTotalRecords(response?.totalCount || response?.responseData?.data?.length || 0);
                        } else {
                              setTableRows([]);
                              setTotalRecords(0);
                        }
                  }
            }

            fetchData();
      }, [appliedFilter, activeTab]);

      //=========================functions========================
      const canView = hasModuleAction("Jobs", "Can View");
      const canInsert = hasModuleAction("Jobs", "Can Insert");
      const canUpdate = hasModuleAction("Jobs", "Can Update");
      const canDelete = hasModuleAction("Jobs", "Can Delete");
      const canChangeStatus = hasModuleAction("Jobs", "Can Change Jobs Status");

      //Confirmation Button Click
      const handleConfirmBtn = async () => {
            setLoader(true);
            if (modelAction === "Delete") {
                  let data = await DeleteClient(
                        modelRequestData.KeyID,
                        authDetails.userKeyID
                  );
                  try {
                        if (data?.statusCode === 200) {
                              setLoader(false);
                              setIsAddUpdateDone(true);
                              setConfirmationModal(false);
                              setShowSuccessPopupModal(true);
                        } else {
                              setLoader(false);
                              setConfirmationModal(false);
                              setIsErrorOpen(true);
                              const errorMessage = data?.response?.data?.errorMessage;
                              setErrorMessage(errorMessage);
                        }
                  } catch (error) {
                        setLoader(false);
                  }
            } else if (modelAction === "Status") {
                  if (activeTab === 1) {
                        try {

                              let data = await UpdateJobStatus(
                                    modelRequestData.jobKeyID
                              );
                              if (data?.statusCode === 200) {
                                    setLoader(false);
                                    setIsAddUpdateDone(true);
                                    setConfirmationModal(false);
                                    setShowSuccessPopupModal(true);
                              } else {
                                    setLoader(false);
                                    setIsErrorOpen(true);
                                    setConfirmationModal(false);
                                    const errorMessage = data?.response?.data?.errorMessage;
                                    setErrorMessage(errorMessage);
                              }
                        } catch (error) {
                              setLoader(false);
                        } finally {
                              setAppliedFilter({
                                    ...appliedFilter
                              })
                        }
                  }
                  else {
                        try {

                              let data = await ChangeClientStatus(
                                    modelRequestData.partiesKeyID
                              );
                              if (data?.statusCode === 200) {
                                    setLoader(false);
                                    setIsAddUpdateDone(true);
                                    setConfirmationModal(false);
                                    setShowSuccessPopupModal(true);
                              } else {
                                    setLoader(false);
                                    setIsErrorOpen(true);
                                    setConfirmationModal(false);
                                    const errorMessage = data?.response?.data?.errorMessage;
                                    setErrorMessage(errorMessage);
                              }
                        } catch (error) {
                              setLoader(false);
                        } finally {
                              setAppliedFilter({
                                    ...appliedFilter
                              })
                        }
                  }
            }
      };
      //Change Page Button
      const HandlePageChange = async (pageNumber) => {
            setCurrentPage(pageNumber);
            setAppliedFilter((prev) => ({ ...prev, pageNo: pageNumber - 1 }));
      };

      const handleSearchFunction = (searchValue) => {
            setValueSearch(searchValue);

            // Clear old timer so API doesn't fire immediately
            if (searchTimer) clearTimeout(searchTimer);

            // Set new timer
            const timer = setTimeout(() => {
                  setAppliedFilter({
                        ...appliedFilter,
                        searchKeyword: searchValue || null,
                  });
            }, 500); // 500ms delay

            setSearchTimer(timer);
      };


      const handleViewClient = (client) => {
            navigate("/viewClient", {
                  state: {
                        clientKeyID: client.clientKeyID,
                        clientName: client.clientName,
                        Action: "View",
                  },
            });
      };

      const handleChangeTab = (tab) => {
            setCurrentPage(1);
            setValueSearch("");
            setAppliedFilter({
                  ...appliedFilter,
                  pageNo: 0,
                  pageSize: pageSize,
                  searchKeyword: null,
            });
            setActiveTab(tab);



            navigate(`?tab=${tab}`); // Update the URL
      };

      const handleStatusClick = (tender) => {

            setSelectedTender(tender);
            setTenderDialogOpen(true);
      };

      const handleJobStatusUpdate = async ({ jobStatusID, jobChangeStatusRemark }) => {
            setLoader(true)
            try {
                  const res = await UpdateStatusJob(
                        {
                              userKeyID: userKeyID,
                              jobKeyID: selectedTender.jobKeyID,   // tender ID
                              jobStatusID: jobStatusID.value,                // selected tender status ID
                              jobChangeStatusRemark: jobChangeStatusRemark
                        }
                  );

                  if (res.statusCode == 200) {
                        setTenderDialogOpen(false);
                        setShowSuccessPopupModal(true);
                  }

                  // refresh table
                  // setAppliedFilter({ ...appliedFilter });
            } catch (error) {
                  console.error(error);
                  setTenderDialogOpen(false);
                  setIsErrorOpen(true);
                  setErrorMessage("Failed to update tender status.");
            } finally {
                  setLoader(false)
            }

      };

      return (
            <>
                  <div className="bg-gray-50 mx-auto mb-10">
                        <div className="bg-white shadow-lg rounded-lg px-6">
                              {/* Tabs */}
                              <div
                                    style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          padding: "4px 15px",
                                    }}
                                    className="p-4 overflow-x-auto"
                              >
                                    <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-4 border-b text-12">
                                          {allTabs
                                                .filter((tab) => {
                                                      if (!defaultAccess?.[tab.accessKey]) return false;

                                                      // Hide Tender tab completely when project name doesn't exist
                                                      if (tab.id === JobEnum.Tender && projectType === 1) {
                                                            return false;
                                                      }

                                                      if (tab.id === JobEnum.Tender && !projectNameState) {
                                                            return false;
                                                      }

                                                      return true;
                                                })
                                                .map((tab) => (
                                                      <button
                                                            key={tab.id}
                                                            className={`px-4 py-2 whitespace-nowrap border-b-2 ${activeTab === tab.id
                                                                  ? "text-[#135EA0] border-b-2 border-[#135EA0] font-semibold"
                                                                  : "border-transparent text-gray-900"
                                                                  }`}
                                                            onClick={() => handleChangeTab(tab.id)}
                                                      >
                                                            {tab.label}
                                                      </button>
                                                ))}
                                    </div>

                              </div>

                              <div className="p-2 border-b flex flex-wrap sm:flex-nowrap items-center justify-between gap-3">

                                    {/* LEFT: Project & Client Info */}
                                    <div className="flex flex-col text-12">
                                          {projectNameState && (
                                                <span className="font-semibold text-[#135EA0]">
                                                      Project Name: <span className="font-normal">{projectNameState}</span>
                                                </span>
                                          )}

                                          {clientNameState && (
                                                <span className="font-semibold text-[#135EA0]">
                                                      Client Name: <span className="font-normal">{clientNameState}</span>
                                                </span>
                                          )}
                                    </div>

                                    {/* RIGHT: Search & Button */}
                                    <div className="flex flex-wrap sm:flex-nowrap items-center w-full sm:w-auto gap-3">
                                          <div className="relative flex items-center w-full sm:w-64">
                                                <input
                                                      type="text"
                                                      className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-sky-600 w-full"
                                                      placeholder="Search"
                                                      value={valueSearch}
                                                      onChange={(e) => handleSearchFunction(e.target.value.trimStart())}
                                                />
                                          </div>
                                          {canInsert && activeTab === 1 ? (
                                                <Tooltip title="Add Jobs">
                                                      <button
                                                            type="button"
                                                            onClick={() => {
                                                                  setModelRequestData({
                                                                        ...modelRequestData,
                                                                        KeyID: null,
                                                                        Action: "Add"
                                                                  });
                                                                  setAddProjectModalOpen(true);
                                                            }}
                                                            className="bg-gradient-to-r from-[#0E4C84] to-[#00A7C1]
                                   hover:from-[#135EA0] hover:to-[#00B8D4]
                                   text-white px-5 py-2 rounded-lg text-12 font-medium
                                   shadow-md transition-all duration-300"
                                                      >
                                                            Add Job
                                                      </button>
                                                </Tooltip>
                                          ) : ('')}
                                    </div>
                              </div>

                              {/* search and button ended  */}

                              {/* Table Section */}
                              {activeTab &&
                                    renderTable(tableColumnsConfig[activeTab], tableRows || [])}
                        </div>
                        <ConfirmationModal
                              show={confirmationModal}
                              onHide={() => setConfirmationModal(false)}
                              actionType={modelAction}
                              onConfirm={handleConfirmBtn}
                              modelRequestData={modelRequestData}
                        />

                        <SuccessModal
                              isOpen={showSuccessPopupModal}
                              onClose={() => {

                                    setShowSuccessPopupModal(false)
                                    setAppliedFilter({
                                          ...appliedFilter
                                    })
                                    // GetProjectListData(1, null);

                              }}
                              modelAction={modelAction}
                              actionMessage={
                                    modelAction === "Status"
                                          ? "Status has been changed successfully!"
                                          : modelRequestData.Name
                              }
                        />
                        <ErrorModal
                              isOpen={isErrorOpen}
                              onClose={() => setIsErrorOpen(false)}
                              errorMessage={errorMessage}
                        />

                        {isAddProjectModalOpen && (
                              <JobsAddUpdateModal
                                    modelRequestData={modelRequestData}
                                    setIsAddUpdateDone={setIsAddUpdateDone}
                                    isOpen={isAddProjectModalOpen}
                                    onClose={() => {
                                          setAddProjectModalOpen(false)
                                          setAppliedFilter({ ...appliedFilter })
                                    }}
                              />
                        )}
                        {isAddProjectOpen && (
                              <AddProjectModal
                                    modelRequestData={modelRequestData}
                                    setIsAddUpdateDone={setIsAddUpdateDone}
                                    isOpen={isAddProjectOpen}
                                    onClose={() => {
                                          setAddProjectOpen(false);

                                          //fetch data
                                          // GetProjectListData(1);
                                    }}
                              // clientKeyID={clientKeyID}
                              />
                        )}
                        <PreviewDialog
                              key={selectedClient?.partiesKeyID}
                              open={previewDialogOpen}
                              onClose={() => setPreviewDialogOpen(false)}
                              jobKeyID={selectedClient?.jobKeyID}
                        />

                        <TenderPreviewDialog
                              partiesKeyID={selectedClient?.partiesKeyID}
                              open={tenderPreviewDialogOpen}
                              onClose={() => setTenderPreviewDialogOpen(false)}
                              jobKeyID={selectedClient?.jobKeyID}
                        />

                        <TenderStatusDialog
                              open={updateTenderDialogOpen}
                              onClose={() => setUpdateTenderDialogOpen(false)}
                              tender={selectedTender}
                              userKeyID={userKeyID}
                              onSubmit={handleTenderStatusUpdate}
                        />

                        <JobStatusDialog
                              open={tenderDialogOpen}
                              onClose={() => setTenderDialogOpen(false)}
                              tender={selectedTender}
                              userKeyID={userKeyID}
                              clientID={clientID}
                              onSubmit={handleJobStatusUpdate}
                        />

                  </div>

            </>
      );
};

export default JobsList;